
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bv-container",
      function () {
        return require("private-next-pages/bv-container.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bv-container"])
      });
    }
  